/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import ReactInputMask, {
  BeforeMaskedStateChangeStates,
  InputState,
} from 'react-input-mask';

interface CurrencyProps extends React.InputHTMLAttributes<HTMLInputElement> {
  inputRef?: React.Ref<HTMLInputElement> | undefined;
  ref?: React.LegacyRef<ReactInputMask> | undefined;
  beforeMaskedStateChange?(states: BeforeMaskedStateChangeStates): InputState;
}

const getMask = (value: string): string => {
  const currentValue = value.toString().split(' ').join('');
  const length = currentValue.length;

  if (length <= 3) {
    return '999 9';
  } else if (length === 4) {
    return '9 999 9';
  } else if (length === 5) {
    return '99 9999';
  } else {
    return '999 999 999 999 999 999 999 999';
  }
};

export const CurrencyInputMask = ({
  ref,
  children,
  ...props
}: CurrencyProps): JSX.Element => {
  const [currencyMask, setCurrencyMask] = useState(
    '999 999 999 999 999 999 999 999',
  );

  useEffect(() => {
    setCurrencyMask(getMask(props.value?.toString() || ''));
  }, [props.value]);

  return (
    <ReactInputMask
      {...props}
      mask={currencyMask}
      onChange={(e) => {
        if (props.onChange) props.onChange(e);
        setCurrencyMask(getMask(e.target.value));
      }}
      alwaysShowMask={false}
      maskPlaceholder=""
      value={props.value || ''}
      maskChar={null}
    >
      {(inputProps: any) => <input {...inputProps} />}
    </ReactInputMask>
  );
};

export default CurrencyInputMask;
